import { ApiClient } from "../api/ApiClient";

export const apiClient = new ApiClient();
